import styled from "styled-components";
import { colors } from "../theme";

export const StyledButton = styled("button")<any>`
  display: flex;
  width: 100%;
  max-width: 10000px;
  padding: 13px 0;
  border: 1px solid ${(p) => p.color || colors.primary};
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  background: ${(p) => p.color || colors.primary};
  box-shadow: 0 12px 24px rgba(12, 46, 78, 0.16);
  color: ${(p) => (p.color ? colors.primary : "#fff")};
  cursor: pointer;
  font-size: 1rem;
  font-weight: 700;
  transition: all 0.3s ease-in-out;

  /* 悬停用比主色亮一档的蓝，白字对比度约 8:1；
     logo 天蓝配白字只有 2.3:1，不能用于填充按钮 */
  &:hover,
  &:active,
  &:focus {
    border-color: ${colors.primaryHover};
    background-color: ${colors.primaryHover};
    color: #fff;
  }
`;
